import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const renameMacro = api(async function renameMacro({ id, newName }) {
    if (!id) return false
    return mutate(
        gql`
            mutation RenameMacro($id: String!, $newName: String!) {
                renameMacro(id: $id, newName: $newName)
            }
        `,
        { id, newName },
        { returns: "renameMacro" }
    )
})
